// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Quh8j","index":"styles_index__2nAfB"};